<template>
  <v-layout row justify-center>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Configurações</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-toolbar-items>
            <v-btn dark flat @click="dialog = false">Salvar</v-btn>
          </v-toolbar-items> -->
        </v-toolbar>
        <!-- <v-list three-line subheader>
          <v-subheader>User Controls</v-subheader>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>Content filtering</v-list-tile-title>
              <v-list-tile-sub-title>Set the content filtering level to restrict apps that can be downloaded</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>Password</v-list-tile-title>
              <v-list-tile-sub-title>Require password for purchase or use password to restrict purchase</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <v-list three-line subheader>
          <v-subheader>General</v-subheader>
          <v-list-tile avatar>
            <v-list-tile-action>
              <v-checkbox v-model="notifications"></v-checkbox>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Notificações</v-list-tile-title>
              <v-list-tile-sub-title>Notificações da agenda</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-action>
              <v-checkbox v-model="sound"></v-checkbox>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Som</v-list-tile-title>
              <v-list-tile-sub-title>Som de mensagens</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider> -->
        <v-list>
          <v-card-text>
            <v-subheader>Redefinir senha</v-subheader>
            <v-form action="#" v-model="valid" ref="form" lazy-validation @submit.prevent="submit()">
              <v-text-field
                label="E-Mail"
                v-model="authentication.username"
                :rules="[v => !!v || 'Você deve informar um e-mail!']" required
                disabled
              ></v-text-field>

              <v-text-field
                class="password"
                ref="password"
                name="input-10-1"
                label="Entre com sua senha"
                hint="Deve conter mais de 6 caracteres"
                v-model="authentication.password"
                min="6"
                :rules="[v => !!v || 'Você deve informar a sua senha!']" required
                :append-icon="p1 ? 'visibility_off' : 'visibility'"
                :type="p1 ? 'password' : 'text'"
                counter
                color="cyan darken"
                loading
                @click:append="p1 = !p1"
              >
                <v-progress-linear v-if="custom" slot="progress" :value="progress" height="8" :color="color"></v-progress-linear>
              </v-text-field>

              <v-text-field
                class="password"
                type="password"
                label="Confirme sua senha"
                v-model="authentication.confpass"
                :rules="[v => !!v || 'Você deve informar a senha!']" required
              ></v-text-field>

              <v-btn
                color = 'primary'
                block
                :disabled="!valid"
                @click="submit()"
              >
                Alterar senha
              </v-btn>
            </v-form>
          </v-card-text>
        </v-list>
      </v-card>
        <v-snackbar
          :timeout="snackbarConfig.timeout"
          :color="snackbarConfig.color"
          :multi-line="snackbarConfig.mode === 'multi-line'"
          :vertical="snackbarConfig.mode === 'vertical'"
          v-model="snackbarConfig.snackbar"
        >
          {{ snackbarConfig.text }}
          <v-btn dark flat @click.native="snackbarConfig.snackbar = false">Fechar</v-btn>
        </v-snackbar>

  </v-layout>

</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'

  export default {
    methods: {
      submit () {
        if (this.$refs.form.validate()) {
          axios.put(`${process.env.URL}/my-clinic-new/auth/profile-reset-password`, {
            id: this.authentication.id,
            username: this.authentication.username,
            password: this.authentication.password
          }, {
            params: {
              customer: this.customer
            }
          }).then((response) => {
            this.snackbarConfig.snackbar = true
            this.snackbarConfig.text = 'Senha Alterada com sucesso!'
          }).catch((err) => {
            if (err.response.data.message) {
              this.snackbarConfig.snackbar = true
              this.snackbarConfig.text = err.response.data.message
              return false
            }
            if (err.response.data.errors) {
              if (err.response.data.errors.username) {
                this.snackbarConfig.snackbar = true
                this.snackbarConfig.text = err.response.data.errors.username.msg
                return false
              }
            }
            this.snackbarConfig.snackbar = true
            this.snackbarConfig.text = err.response.data.result.error
          })
        }
      }
    },
    mounted () {
      this.authentication.id = this.getUser.user.id
      this.authentication.username = this.getUser.user.username
    },
    computed: {
      ...mapGetters({
        customer: 'customer'
      }),
      ...mapGetters('app', ['getTheme', 'getPkg']),
      ...mapGetters('auth', ['getUser']),
      progress () {
        return Math.min(100, this.authentication.password.length * 10)
      },
      color () {
        return ['error', 'warning', 'success'][Math.floor(this.progress / 40)]
      }
    },
    data () {
      return {
        dialog: false,
        notifications: false,
        sound: true,
        widgets: false,
        env: process.env.URL,
        snackbarConfig: {
          snackbar: false,
          color: 'error',
          mode: '',
          timeout: 6000,
          text: 'Erro de conexão com o servidor!'
        },
        valid: true,
        e1: true,
        p1: true,
        custom: true,
        authentication: {
          id: '',
          username: '',
          password: '',
          confpass: ''
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/settings/index.vue